<template>
  <card-item
    card="item_calculator"
    :tabs="tabs"
    :disableId="true"
    v-model="activeTab"
    :id="`${id}`"
  >
  </card-item>
</template>
<script>
export default {
  methods: {},
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Калькулятор",
          key: "cacl",
          component: () => import("./Info"),
        },
        {
          title: "Узнать ИНН",
          key: "know_inn",
          component: () => import("./Inn"),
        },
      ],
      activeTab: 0,
    };
  },
};
</script>